import CsvTable from './Editor/CsvEditor/CsvTable';
import { CsvProvider, useCsvEditor } from './Editor/CsvEditor/context';
export default {
  Editor: {
    CsvEditor: {
      CsvProvider: CsvProvider,
      CsvTable: CsvTable,
      useCsvEditor: useCsvEditor
    }
  },
  Preview: {}
};